var map = {
	"./video-carousel.de-CH.json": 1518,
	"./video-carousel.de-DE.json": 1519,
	"./video-carousel.en-CA.json": 1520,
	"./video-carousel.en-GB.json": 1521,
	"./video-carousel.en-IN.json": 1522,
	"./video-carousel.en-ME.json": 1523,
	"./video-carousel.en-US.json": 1524,
	"./video-carousel.es-EM.json": 1525,
	"./video-carousel.es-ES.json": 1526,
	"./video-carousel.fr-BE.json": 1527,
	"./video-carousel.fr-CA.json": 1528,
	"./video-carousel.fr-CH.json": 1529,
	"./video-carousel.nl-BE.json": 1530,
	"./video-carousel.nl-NL.json": 1531,
	"./video-carousel.pl-PL.json": 1532,
	"./video-carousel.pt-BR.json": 1533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1517;